<template>
  <div class="zmgzraank">
    <sub-title :text="title" />
    <div class="list">
      <div class="item between" v-for="item in xhnum" :key="item">
        <div class="flex_start">
          <div
            class="sort center"
            :class="{ sort1: item == 1, sort2: item == 2, sort3: item == 3 }"
          >
            {{ item }}
          </div>
          <div class="text ellipsis">非法收购、运输、出售</div>
        </div>
        <div class="num">452人关注</div>
      </div>
    </div>
  </div>
</template>


<script>
import subTitle from "views/home/components/subTitle";
export default {
  props: {
    title: {
      type: String,
      default: "热门罪名关注排行榜",
    },
    xhnum: {
      type: Number,
      default: 10,
    },
  },
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.zmgzraank {
  padding: 23px 12px;
  .list {
    padding: 10px 5px 0 5px;
    .item {
      margin-top: 20px;
      cursor: pointer;
      &:hover{
          .text {
          color: #0465EA;}
      }
      .sort {
        width: 20px;
        height: 20px;
        background: #f4f4f5;
        border-radius: 50%;
        font-size: 12px;
        color: #9295a2;
      }
      .sort1 {
        color: #fff;
        background-image: linear-gradient(#f7e490, #f0c648);
      }
      .sort2 {
        color: #fff;
        background-image: linear-gradient(#c6d9ee, #a3c3e7);
      }
      .sort3 {
        color: #fff;
        background-image: linear-gradient(#dfcfc0, #d8b999);
      }
      .text {
        font-size: 14px;
        color: #666666;
        margin-left: 9px;
        width: 180px;
      }
      .num {
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
</style>